
import {defineComponent, PropType} from "vue";
import {Campaign} from "@/models/campaign";
import BackgroundImageMixin from "@/components/recorder/BackgroundImageMixin.vue";
import {mapActions} from "pinia";
import {useAnalyticsStore} from "@/store/analytics.store";

interface Data {
    rating: number | undefined;
}

export default defineComponent({
    name: "SurveyNPSView",
    props: {
        campaign: {
            required: true,
            type: Object as PropType<Campaign>
        },
        initialQuestion: {
            required: true,
            type: String
        }
    },
    data(): Data {
        return {
            rating: undefined,
        }
    },
    mixins: [BackgroundImageMixin],
    mounted() {
        this.trackEvent('creationNPSView', {
            ...this.$analytics.campaignParams(this.campaign),
        })
    },
    computed: {
        agentMessage(): string {
            return this.initialQuestion;
        },
        showContinueButton() {
            return this.rating !== undefined;
        },
    },
    methods: {
        // analytics store
        ...mapActions(useAnalyticsStore, ['trackPageView']),
        ...mapActions(useAnalyticsStore, ['trackEvent']),

        next(): void {
            if (this.rating === undefined) {
                return;
            }

            this.$emit('finished', this.rating);
        },
    }
});
